
import { SelfDestructTimeSettingsScreenNavigationProps } from "./types"
import React from "react"
import SelfDestructTimeSettings from "./self-destruct-time-settings-screen"
import { PageRoot } from "~screens/page-root"


// 自毁时间设置
const SelfDestructTimeSettingsScreen: React.FC<SelfDestructTimeSettingsScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <SelfDestructTimeSettings route={route} />
    </PageRoot>
  )
}

export default SelfDestructTimeSettingsScreen
